import React from "react";
export const sortByProperty = (property) => {
    return function (a, b) {
        if (parseFloat(a[property]) > parseFloat(b[property])) return 1;
        else if (parseFloat(a[property]) < parseFloat(b[property])) return -1;

        return 0;
    };
}

export const setTime = (time) => {
    var date = new Date(time);

    return date.toLocaleString([], {
        hour: "2-digit",
        minute: "2-digit",
    });
}

export const displayDateFromSlateTimeFrame = (slateDate) => {
    const date = new Date(slateDate);
    const last2 = date.getFullYear().toString().substring(2);

    return (
        date.toDateString().split(" ")[0] +
        " " +
        date.getDate() +
        "/" +
        parseInt(date.getMonth() + 1) +
        "/'" +
        last2
    );
}
export const timeFrameDisplay = (selectedTimeframe) => {
    const time = new Date(selectedTimeframe);
    let mm = time.getMonth() + 1; // Months start at 0!
    let dd = time.getDate();
    const last2 = time.getFullYear().toString().substring(2);

    if (dd < 10) dd = "0" + dd;
    if (mm < 10) mm = "0" + mm;

    const toReturn = dd + "/" + mm + "/'" + last2;
    console.log("Date Permanent Timeframe timeFrameDisplay:: ", toReturn);
    return <span className="text-white"> | {toReturn}</span>;
};

export const goHome = (e) => {
    e.preventDefault();
    window.location.href = "https://spontasy.com";
};

export const scrollHorizontal = (e) => {
    e.preventDefault();
    var container = document.getElementById("ul-horizontal-scroll");
    var containerScrollPosition = document.getElementById(
        "ul-horizontal-scroll"
    ).scrollLeft;

    console.log("ContainerScrolPos: ", containerScrollPosition);
    console.log("e.DeltaY: ", e.deltaY);
    console.groupEnd();

    container.scrollTo({
        top: 0,
        left: containerScrollPosition + e.deltaY,
        behaviour: "smooth", //if you want smooth scrolling
    });
}